import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as PriorityMedium } from 'assets/svg/icon-priority-medium.svg'

function IconPriorityMedium(props: IconProps): JSX.Element {
  const title = 'icon-priority-medium'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <PriorityMedium {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconPriorityMedium
